import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PolicyQuery} from 'src/app/modules/policy/state/policy.query';
import {Question} from '../../models/underwriter.model';
import {newGuid} from '../question-helper';

@Component({
    selector: 'app-question-multiselect-grouped',
    templateUrl: './question-multiselect-grouped.component.html',
    styleUrls: ['./question-multiselect-grouped.component.scss'],
    standalone: false
})
export class QuestionMultiselectGroupedComponent implements OnInit {

  @Input() question: Question
  @Output() questionAnswer = new EventEmitter();

  uniqueControlName = `multi-select-grouped-${newGuid()}`;
  items: any[] = [];

  constructor(private policyQuery: PolicyQuery) { }

  ngOnInit(): void {
    this.items = [];
    const policy: any = this.policyQuery.getActive();
    if (policy !== undefined) {
      const currentClassItems = policy.collation?.filter((item: any) => item.class_id === this.question.product_class_id && item.entry_type === 'item');
      if (currentClassItems?.length > 0) {
        currentClassItems.forEach((class_item: any) => {
          const checked = false;
          const item = {
            id: class_item.calc_collation_id,
            item_id: class_item.session_item_id,
            header: class_item.description_1?.split('|')[0],
            description: class_item.description_2,
            checked,
            class_id: this.question.class_id,
          };
          this.items.push(item);
        });
      }
    }
  }



  getHeadings(){
    let groupsDict : {} = this.items.reduce((r:any,a:any) => {
      r[a.header] = [...r[a.header] || [], a];
      return r;
    }, {});

    let groupArray = Object.entries(groupsDict);
    let headings = [];
    groupArray?.forEach((item: any) => {
      headings.push(item[0]);
    });
    return headings;
  }

  getItems(header: any){
    return this.items.filter((item: any) => item.header == header);
  }


  checkMultiSelect(): void {
    const selectedOptions = [];
    const checkboxes = document.getElementsByName(`${this.uniqueControlName}`);

    // @ts-ignore
    for (const c of checkboxes) {
      const el = c as HTMLInputElement;
      if (el.checked) {
        selectedOptions.push(el.value);
      }
    }
    if (selectedOptions?.length) {
      this.submitAnswer(selectedOptions.join('|'));
    }
  }

  submitAnswer(value: any): void {
    if (this.question) {
      this.question.answer = value;
      this.questionAnswer.emit(this.question);
    } else {
      this.questionAnswer.emit(value);
    }
  }

}
